// Define all the objects in alphabetical order

const UserRoles = {
  1: "ADMIN",
  2: "RA",
  3: "BDM",
  4: "RECRUITER",
  5: "HR",
  6: "FINANCE",
  7: "EMPLOYEE",
};

const UserDesignations = {
  1: "JUNIOR",
  2: "SENIOR",
  3: "LEAD",
  4: "MANAGER",
  5: "EMPLOYEE",
};

const OrganizationStatus = {
  1: "ACTIVE",
  2: "INACTIVE",
};

const CompanyStatus = {
  1: "ACTIVE",
  2: "INACTIVE",
  3: "BLOCKED",
  4: "DNC",
};

const EmploymentType = {
  1: "REGULAR",
  2: "PERMANENT",
  3: "CONTRACTOR",
  4: "REFERENCE",
};

const Gender = {
  1: "MALE",
  2: "FEMALE",
  3: "WISH NOT TO SPECIFY",
  4: "OTHER",
};

const EmployeeStatus = {
  1: "ACTIVE",
  2: "INACTIVE",
  3: "ON HOLD",
  4: "REJECTED",
  5: "RESIGN",
  6: "TERMINATION",
};

const EmployeeTagJobStatus = {
  1: "ACTIVE",
  2: "OPEN",
};

const EmployeeClassification = {
  1: "BILLABLE",
  2: "NONBILLABLE",
};

const EmployeeExitType = {
  1: "EMPLOYMENT EXIT",
  2: "CONTRACT EXPIRY",
  3: "RESIGNATION",
  4: "TERMINATION",
  5: "RETIREMENT",
  6: "SERVING NOTICE",
};

const InvoiceBillType = {
  1: "SALARY",
  2: "INCENTIVES",
  3: "BONUS",
  4: "ALLOWANCE",
};

const InvoiceStatus = {
  1: "ACTIVE",
  2: "OPEN",
};

const JobStatus = {
  1: "ACTIVE",
  2: "OPEN",
};

const ContactStatus = {
  1: "ACTIVE",
  2: "OPEN",
};

const RecordStatus = {
  1: "ACTIVE",
  2: "INACTIVE",
};

const ClientOwnership = {
  1: "VISIBLE TO ALL",
  2: "VISIBLE TO SELECTED OWNERS",
};

const ContactType = {
  1: "PRIMARY",
  2: "SECONDARY",
};

const CurrencyType = {
  1: "USD",
  2: "INR",
};

const CommissionType = {
  1: "FLAT",
  2: "PERCENTAGE",
};

const NotifierDefault = {
  1: "END CLIENT NAME",
  2: "LOCATION",
  3: "EMPLOYEE NAME",
  4: "JOB START DATE",
  5: "JOB END DATE",
  6: "JOB TITLE",
  7: "EMPLOYEE ID",
};

const VisibilityStatus = {
  1: "ACTIVE",
  2: "INACTIVE",
};

const DiscountType = {
  1: "PERCENTAGE",
  2: "VALUE",
};

const InvoiceDateCalculation = {
  1: "LAST DATE OF TIMESHEET IN INVOICE LINE ITEMS",
  2: "INVOICE CREATION DATE",
};

const InvoiceDueDateCalculation = {
  1: "SHIPPED DATE",
  2: "INVOICE DATE",
};

const BusinessSize = {
  1: "SMALL",
  2: "MEDIUM",
  3: "LARGE",
};

const BusinessType = {
  1: "CORPORATION",
  2: "FRANCHISE",
  3: "LLC",
  4: "PARTNERSHIP",
  5: "SOLO PROPRIETOR",
};

const BankAccType = {
  1: "SAVINGS",
  2: "CHECKING",
  3: "CURRENT",
};

const DepositAmtType = {
  1: "FULL",
  2: "PARTIAL",
};

const Ethnicity = {
  1: "Asian",
  2: "Black / African",
  3: "Hispanic / Latino",
  4: "White / Caucasian",
  5: "Middle Eastern / North African",
  6: "Native American / Indigenous",
  7: "Pacific Islander",
  8: "Mixed / Multiracial",
  9: "Other",
  10: "Prefer not to say",
};

const WADocStatus = {
  1: "Active",
  2: "Filed Extension",
  3: "Inactive",
};

const WADocType = {
  1: "Citizen",
  2: "CPT",
  3: "Driving License",
  4: "GC EAD",
  5: "Green Card",
  6: "H-1B",
  7: "H4",
  8: "H4 EAD",
  9: "L2 EAD",
  10: "OPT",
  11: "STEM OPT",
};

const H1BStatus = {
  1: "Draft",
  2: "Filed",
  3: "RFE Received",
  4: "Approved",
  5: "Denied",
  6: "Motion to Re-Open",
  7: "RFE Approved",
  8: "RFE Denied",
  9: "End of Workflow",
  10: "Revoked",
};

const PassportStatus = {
  1: "Active",
  2: "Inactive",
};

const PlacementType = {
  1: "Contract",
  2: "Permanent",
};

const DocumentStatus = {
  1: "Active",
  2: "Inactive",
};

const WorkLocationType = {
  1: "Onsite",
  2: "Remote",
  3: "Offshore",
};

const PayType = {
  1: "Hourly",
  2: "Salary",
};

const TimesheetCycles = {
  1: "Daily",
  2: "Weekly",
  3: "Biweekly",
  4: "Monthly",
  5: "Semi Monthly",
  6: "By Dates",
};

const Weekdays = {
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
  7: "Sunday",
};

const BillRateType = {
  1: "Per hour",
  2: "Per day",
  3: "Per week",
  4: "Per month",
  5: "Per annum",
};

const TimesheetFormat = {
  1: "Regular",
  2: "Timesheets with Time Clock",
};

const TimesheetSubmitMethod = {
  1: "Individual Timesheets",
  2: "On Behalf of employees",
};

const ApprovalType = {
  1: "Internal",
  2: "External",
};

const BillType = {
  1: "Billable",
  2: "Non-billable",
};

const RHSCOptions = {
  1: "Show Warning Only",
  2: "Restrict",
  3: "Do Nothing",
};

const TimesheetStatus = {
  1: "Weekends",
  2: "Draft",
  3: "Submitted",
  4: "Approved",
  5: "Rejected",
  6: "Job Inactive",
  7: "Leave",
  8: "Discrepant",
  9: "Invoiced",
};
const FederalFilingStatus = {
  1: "Single or Married filing separately",
  2: "Married filing jointly or Qualifying surviving spouse",
  3: "Head of Household",
};

export const getValueByKey = (key, type) => {
  const mappings = {
    ApprovalType,
    BankAccType,
    BillRateType,
    BillType,
    BusinessSize,
    BusinessType,
    ClientOwnership,
    CommissionType,
    CompanyStatus,
    ContactStatus,
    ContactType,
    CurrencyType,
    DepositAmtType,
    DiscountType,
    DocumentStatus,
    EmployeeClassification,
    EmployeeExitType,
    EmployeeStatus,
    EmployeeTagJobStatus,
    EmploymentType,
    Ethnicity,
    FederalFilingStatus,
    Gender,
    H1BStatus,
    InvoiceBillType,
    InvoiceDateCalculation,
    InvoiceDueDateCalculation,
    InvoiceStatus,
    JobStatus,
    NotifierDefault,
    OrganizationStatus,
    RecordStatus,
    TimesheetCycles,
    TimesheetFormat,
    TimesheetSubmitMethod,
    TimesheetStatus,
    UserDesignations,
    UserRoles,
    VisibilityStatus,
    PassportStatus,
    PayType,
    PlacementType,
    RHSCOptions,
    WADocStatus,
    WADocType,
    Weekdays,
    WorkLocationType,
  };
  //return mappings[type]?.[key] || "Unknown";
  return mappings[type]?.[key] || "-";
};

// Test usage examples
// console.log(getValueByKey(1, "UserRoles )); // Output: "ADMIN"
// console.log(getValueByKey(2,"CurrencyType")); // Output: "INR"
// console.log(getValueByKey(3,"CommissionType")); // Output: "FLAT"
// console.log(getValueByKey(4,"InvoiceBillType")); // Output: "ALLOWANCE"
// console.log(getValueByKey(1,"BusinessSize")); // Output: "LARGE"
// console.log(getValueByKey(2,"BankAccType")); // Output: "CHECKING"
// console.log(getValueByKey(1,"DiscountType")); // Output: "Unknown Key"
